import {
  defaultPrimaryColor,
  defaultButtonTextColor,
  defaultHyperlinkColor,
  defaultLogoMinWidth,
  defaultLogoMinHeight,
} from '../styles/Variables';

export interface Config {
  readonly appName: string;
  readonly appVersion: string;

  readonly registrationAPIRegion: string;
  readonly registrationAPIURL: string;

  readonly cognitoAWSRegion: string;
  readonly cognitoAWSUserPoolID: string;
  readonly cognitoAWSIdentityPoolID: string;
  readonly cognitoAWSAppClientID: string;
  readonly cognitoAWSCookieDomain: string;

  readonly companyThemeName: string;
  readonly companyPrimaryColorCode: string;
  readonly companyBackgroundImageUrl: string;
  readonly companyRegistrationBackgroundImageUrl: string;
  readonly companyLogoUrl: string;
  readonly buttonTextColorCode: string;
  readonly hyperlinkColorCode: string;
  readonly companyLogoMinWidth: string;
  readonly companyLogoMinHeight: string;

  readonly companyID: string;
  readonly companyName: string;
  readonly companyFullName: string;
  readonly companyAppClientID: string;
  readonly companyMarketplaceURL: string;
  readonly companyTermsURL: string;
  readonly companyPDPAURL: string;
  readonly companyPDNoticeURL: string;
  readonly companyPrefIDs: {
    name: string,
    id: string,
  }[] | null;
  readonly signUpEnabled: boolean;
  readonly isClientIDEnabled: boolean;
  readonly isEmailVerificationEnabled: boolean;
}

/**
 * Returns company preference ids in a list
 * @param ids list of ids "xxx-id-1:Ser%201,xxx-id-2:Ser%202" (name must be URL encoded)
 */
function generateCompanyPrefIDs(ids?: string): {
  name: string,
  id: string,
}[] | null {
  if (!ids) {
    return null;
  }
  const companies: {
    name: string,
    id: string,
  }[] = [];
  const comsEnv = ids.split(',');
  comsEnv.forEach((env) => {
    const comEnv = env.split(':');
    if (comEnv.length !== 2) {
      throw new Error('invalid preferred company env (should be "xxx-id-1:Ser%201,xxx-id-2:Ser%202")');
    }
    companies.push({
      id: comEnv[0],
      name: decodeURIComponent(comEnv[1]),
    });
  });
  return companies;
}

const config: Config = {
  appVersion: process.env.REACT_APP_VERSION || '0.0.0',
  appName: process.env.REACT_APP_NAME || 'MHub Secure Consumer',
  registrationAPIRegion: process.env.REACT_APP_REGISTRATION_API_REGION || '',
  registrationAPIURL: process.env.REACT_APP_REGISTRATION_API_URL || '',
  cognitoAWSRegion: process.env.REACT_APP_COGNITO_AWS_REGION || '',
  cognitoAWSUserPoolID: process.env.REACT_APP_COGNITO_AWS_USER_POOL_ID || '',
  cognitoAWSIdentityPoolID: process.env.REACT_APP_COGNITO_AWS_IDENTITY_POOL_ID || '',
  cognitoAWSAppClientID: process.env.REACT_APP_COGNITO_AWS_APP_CLIENT_ID || '',
  cognitoAWSCookieDomain: process.env.REACT_APP_COGNITO_AWS_COOKIE_DOMAIN || '',

  companyThemeName: process.env.REACT_APP_THEME_NAME || '',
  companyPrimaryColorCode: process.env.REACT_APP_PRIMARY_COLOR_CODE || defaultPrimaryColor,
  companyBackgroundImageUrl: process.env.REACT_APP_BACKGROUND_IMAGE_URL || '',
  companyRegistrationBackgroundImageUrl: process.env.REACT_APP_REGISTRATION_BACKGROUND_IMAGE_URL || '',
  companyLogoUrl: process.env.REACT_APP_COMPANY_LOGO_URL || '',
  buttonTextColorCode: process.env.REACT_APP_BUTTON_TEXT_COLOR_CODE || defaultButtonTextColor,
  hyperlinkColorCode: process.env.REACT_APP_HYPERLINK_COLOR_CODE || defaultHyperlinkColor,
  companyLogoMinWidth: process.env.REACT_APP_LOGO_MINWIDTH || defaultLogoMinWidth,
  companyLogoMinHeight: process.env.REACT_APP_LOGO_MINHEIGHT || defaultLogoMinHeight,

  companyID: process.env.REACT_APP_COMPANY_ID || '',
  companyName: process.env.REACT_APP_COMPANY_NAME || '',
  companyFullName: process.env.REACT_APP_COMPANY_FULL_NAME || '',
  companyAppClientID: process.env.REACT_APP_COGNITO_AWS_APP_CLIENT_ID || '',
  companyMarketplaceURL: process.env.REACT_APP_COMPANY_MARKETPLACE_URL || '',
  companyTermsURL: process.env.REACT_APP_COMPANY_TERMS_URL || '',
  companyPDPAURL: process.env.REACT_APP_COMPANY_PDPA_URL || '',
  companyPDNoticeURL: process.env.REACT_APP_COMPANY_PDNOTICE_URL || '',
  companyPrefIDs: generateCompanyPrefIDs(process.env.REACT_APP_COMPANY_PREF_IDS),
  signUpEnabled: !Boolean(process.env.REACT_APP_DISABLEDSIGNUP),
  isClientIDEnabled: Boolean(process.env.REACT_APP_CLIENTID) || false,
  isEmailVerificationEnabled: Boolean(process.env.REACT_APP_ENABLED_EMAIL_VERIFICATION) || false
};

export default config;
